import { z } from 'zod';

export const errorCodes = [
  'validation_error',
  'unauthorized',
  'forbidden',
  'not_found',
  'rate_limited',
  'invalid_credentials',
  'invalid_token',
  'email_taken',
  'oauth_failed',
  'oauth_cancelled',
  'oauth_email_unverified',
  'calendar_unavailable',
  'calendar_failed',
  'calendar_busy',
  'internal_error',
] as const;

export const errorCodeSchema = z.enum(errorCodes);
export type ErrorCode = z.infer<typeof errorCodeSchema>;

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof apiErrorSchema>;
